import { useEffect, useRef, useState } from "react"
import { HERO_ICONS } from "./Icons"
import { TabButton } from "./TabButton"
import { cn } from "@utils/tw"

export const InlineVideo = ({ src, className }: { src: string; className?: string }) => {
  const videoRef = useRef<HTMLVideoElement | null>(null)
  const [playing, setPlaying] = useState(true)

  useEffect(() => {
    if (videoRef.current) {
      if (playing) {
        videoRef.current.play()
      } else {
        videoRef.current.pause()
      }
    }
  }, [playing])

  return (
    <div className={cn("w-full aspect-video relative rounded-md overflow-hidden", className)}>
      <video ref={videoRef} className="w-full h-full object-contain" autoPlay={playing} loop muted playsInline>
        <source src={src} type="video/mp4" />
        Your browser does not support the video tag.
      </video>
      <TabButton className="absolute right-4 bottom-4" onClick={() => setPlaying(!playing)}>
        <div className="w-5 h-5">{playing ? HERO_ICONS["pause"] : HERO_ICONS["play"]}</div>
      </TabButton>
    </div>
  )
}
